export interface Vector2 {
  x: number;
  y: number;
}

export const ZERO: Vector2 = Object.freeze({ x: 0, y: 0 })
export const UNIT_X: Vector2 = Object.freeze({ x: 0, y: 0 })
export const UNIT_Y: Vector2 = Object.freeze({ x: 0, y: 1 })

export function magnitude (v: Vector2): number {
  return Math.sqrt(v.x * v.x + v.y * v.y)
}

export function unit (v: Vector2): Vector2 {
  const m = magnitude(v)
  return { x: v.x / m, y: v.y / m }
}

export function add (a: Vector2, b: Vector2): Vector2 {
  return { x: a.x + b.x, y: a.y + b.y }
}

export function subtract (a: Vector2, b: Vector2): Vector2 {
  return { x: a.x - b.x, y: a.y - b.y }
}

export function multiply (v: Vector2, n: number): Vector2 {
  return { x: v.x * n, y: v.y * n }
}

export function divide (v: Vector2, n: number): Vector2 {
  return { x: v.x / n, y: v.y / n }
}

export function negate (v: Vector2): Vector2 {
  return { x: -v.x, y: -v.y }
}

export function direction (v: Vector2): number {
  return Math.atan2(v.y, v.x)
}

export function distanceTo (a: Vector2, b: Vector2): number {
  return magnitude(subtract(a, b))
}

export function dotProduct (a: Vector2, b: Vector2): number {
  return b.x * a.x + b.y * a.y
}

export function equals (a: Vector2, b: Vector2, epsilon = Number.EPSILON): boolean {
  return a === b || (
    Math.abs(a.x - b.x) <= epsilon &&
    Math.abs(a.y - b.y) <= epsilon
  )
}
